import {AddOn} from "@softline/application";
import { Signal } from '@angular/core';

export interface FreigabeAddOnParams {
  selected: Signal<any>
}

export abstract class FreigabeAddOn extends AddOn<FreigabeAddOnParams> { }
